import moment from "moment";

export const formatTimeRange = (start, end, dash = true) => {
  const localStart = start ? moment.utc(start).local() : null;
  const localEnd = end ? moment.utc(end).local() : null;

  if (!localStart && !localEnd) {
    return "8.00 pm Onwards";
  } else if (localStart && !localEnd) {
    return `${localStart.format("h:mm a")} Onwards`;
  } else if (!localStart && localEnd) {
    return "8.00 pm Onwards";
  } else {
    const startFormat = localStart.minutes() === 0 ? "h" : "hh:mm";
    const endFormat = localEnd.minutes() === 0 ? "h" : "hh:mm";
    return `${localStart.format(startFormat + " a")} ${
      dash ? "-" : "to"
    } ${localEnd.format(endFormat + " a")}`;
  }
};

export const formatMoney = (value) => {
  if (value == null || value === "") return "₹0";
  try {
    const formatted = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(value);

    return `₹ ${formatted}`;
  } catch (error) {
    console.log("Money format error:", error);
    return value;
  }
};
